import { createSlice } from 'utils/@reduxjs/toolkit';
import { CouplingAndBracketState } from './types';
import { reducers } from './reducers';

export const initialState: CouplingAndBracketState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'couplingsAndBrackets',
  initialState,
  reducers,
});

export const { actions: couplingsAndBracketsActions } = slice;
export const { reducer: couplingsAndBracketsReducer } = slice;
